<!--个人中心左侧公共导航 @zjf-2020-12-26-->
<template>
  <div class="sld_member_left_nav">
    <!-- <template v-for="(item, index) in leftNavMenu" :key="index">
    
    <div @click="user_menu(item.path)" class="menu">
        <i :class="{ iconfont: true, [item.icon]: true }"></i>
        {{ item.name }}
      </div>
    <template v-if="item.child.length">
        <template
          v-for="(item_child, index_child) in item.child"
          :key="index_child"
        >
          <router-link
            v-if="testIfShow(item_child)"
            :to="{ path: item_child.path, query: item_child.query }"
            :class="{
              submenu: true,
              cur_code_active: curCode == item_child.code
            }"
            >{{ item_child.name }}</router-link
          >
        </template>
      </template>
    </template> -->
    <el-menu>
      <router-link to="/member/index">
        <el-menu-item index="2">
          <!-- <span class="iconfont icon-gerenzhongxinguanzhu workdeskIcon"></span> -->
          <img class="chicun" src="@/assets/user_center/workdesk.png" alt="" />
          <span>{{ L['工作台'] }}</span>
        </el-menu-item>
      </router-link>
      <el-submenu class="renzhengcenter">
        <template #title>
          <!-- <i class="iconfont icon-gerenzhongxinguanzhu authentication"></i> -->
          <img
            class="chicun2"
            src="@/assets/user_center/authentication.png"
            alt=""
          />
          <span>{{ L['认证中心'] }}</span>
        </template>
        <router-link
          :to="
            '/member/authentication?id=' +
              memberInfo.info.isAuth +
              '&name=' +
              memberInfo.info.memberTrueName +
              '&number=' +
              memberInfo.info.memberIdCard
          "
        >
          <el-menu-item index="1.1">{{ L['实名认证'] }}</el-menu-item>
        </router-link>
        <router-link to="/member/pointOrder/list2">
          <el-menu-item index="2.2">{{ L['企业认证'] }}</el-menu-item>
        </router-link>
      </el-submenu>

      <el-submenu
        v-for="(item, index) in leftNavMenu"
        :key="index"
        :index="resolveIndex(index)"
      >
        <template #title>
          <!-- <i class="icon" :class="{ iconfont: true, [item.icon]: true }"></i> -->
          <!-- {{ item.image_path }} -->
          <img class="chicun" :src="item.image_path" alt="" />
          <span>{{ item.name }}</span>
        </template>
        <el-menu-item
          @click="menuitem(item_child.path)"
          v-for="(item_child, index_child) in item.child"
          :key="index_child"
          :index="item_child.path"
          >{{ item_child.name }}</el-menu-item
        >
      </el-submenu>

      <router-link to="/member/robot">
        <el-menu-item index="99">
          <img class="chicun" src="@/assets/user_center/workdesk.png" alt="" />
          <span>AI Sourcing Assistant</span>
        </el-menu-item>
      </router-link>
    </el-menu>
  </div>
</template>

<script>
import { getCurrentInstance, watchEffect, ref, reactive, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
export default {
  name: 'MemberLeftNav',
  components: {},
  setup () {
    const handleClose = () => {
      console.log()
    }
    const memberInfo = reactive({ info: {} })
    const store = useStore()
    const router = useRouter()
    const { proxy } = getCurrentInstance()
    const L = proxy.$getCurLanguage()
    const curCode = ref('')
    const isAuth = ref('')
    const memberTrueName = ref('')
    const memberIdCard = ref('')
    console.log('memberInfo---000---', memberInfo.info)
    watchEffect(() => {
      let tmpPath = router.currentRoute.value.fullPath
      if (
        router.currentRoute.value.name != undefined &&
        router.currentRoute.value.name
      ) {
        curCode.value = router.currentRoute.value.name
        if (tmpPath == '/member/collect?type=store') {
          curCode.value = 'memberCollectStore' //关注店铺
        } else if (
          tmpPath == '/member/order/aftersales?type=return' ||
          tmpPath.indexOf('/member/order/refund/detail?curTitleId=2') > -1
        ) {
          curCode.value = 'AfterSalesListReturn' //我的退货
        } else if (
          tmpPath == '/member/order/aftersales' ||
          tmpPath.indexOf('/member/order/refund/detail?curTitleId=1') > -1
        ) {
          curCode.value = 'AfterSalesList' //我的退款
        }
      }
    })
    const getInitInfo = () => {
      //获取会员信息数据
      proxy.$get('/v3/member/front/member/getInfo').then(res => {
        if (res.state == 200) {
          memberInfo.info = res.data
          isAuth.value = res.data.isAuth
          memberTrueName.value = res.data.memberTrueName
          memberIdCard.value = res.data.memberIdCard
          store.commit('updateMemberInfo', memberInfo.info) //将购物车数据存储到vuex的store中
        }
      })
    }
    // const leftNavMenu2 = [
    //   {
    //     code: 'authentication',
    //     icon: 'icon-anquan',
    //     name: '认证中心',
    //     path: '/member/index',
    //     child: [
    //       {
    //         code: 'renzheng',
    //         name: L['实名认证'],
    //         path: '/member/authentication'
    //       },
    //       {
    //         code: 'componanyrenzheng',
    //         name: L['企业认证'],
    //         path: '/member/pointOrder/list2'
    //       }
    //     ]
    //   }
    // ]
    const leftNavMenu = [
      {
        code: 'tarde',
        icon: 'icon-gerenzhongxinjiaoyizhongxin',
        image_path: require('@/assets/user_center/transaction.png'),
        name: L['交易中心'],
        path: '/member/index',
        child: [
          {
            code: 'xuenjia',
            name: L['发布询价'],
            path: '/member/xuenjia/fabuxuenjia'
          },
          {
            code: 'xuanjiada',
            name: L['询价记录'],
            path: '/member/xuanjiada/xuenjiajilu'
          },
          {
            code: 'memberOrderList',
            name: L['我的订单'],
            path: '/member/order/list'
          },
          {
            code: 'MemberOrderEvaluation',
            name: L['交易评价/晒单'],
            path: '/member/order/evaluation'
          }
        ]
      },
      {
        code: 'collect',
        icon: 'icon-gerenzhongxinguanzhu',
        image_path: require('@/assets/user_center/follow.png'),
        name: L['关注中心'],
        path: '/member/index',
        child: [
          {
            code: 'MemberCollect',
            name: L['我的收藏'],
            path: '/member/collect'
          },
          {
            code: 'memberCollectStore',
            query: { type: 'store' },
            name: L['关注工厂'],
            path: '/member/collect?type='
          },
          {
            code: 'MemberFootprint',
            name: L['我的足迹'],
            path: '/member/footprint'
          }
        ]
      },
      {
        code: 'service',
        icon: 'icon-gerenzhongxinkehufuwu',
        image_path: require('@/assets/user_center/service.png'),
        name: L['客户服务'],
        path: '/member/index',
        child: [
          {
            code: 'AfterSalesList',
            name: L['我的退款'],
            path: '/member/order/aftersales'
          },
          {
            code: 'AfterSalesListReturn',
            query: { type: 'return' },
            name: L['我的退货'],
            path: '/member/order/aftersales?type=return'
          }
        ]
      },
      {
        code: 'member',
        icon: 'icon-gerenzhongxinhuiyuanzhongxin',
        image_path: require('@/assets/user_center/Account.png'),
        name: L['会员中心'],
        path: '/member/index',
        child: [
          {
            code: 'MemberInfo',
            name: L['会员信息'],
            path: '/member/info'
          },
          {
            code: 'MemberAccount',
            name: L['账号安全'],
            path: '/member/account'
          },
          {
            code: 'MemberPhoneMange',
            name: L['手机号管理'],
            path: '/member/phone'
          },
          {
            code: 'memberEmailMange',
            name: L['邮箱管理'],
            path: '/member/email'
          },
          {
            code: 'MemberLoginPassword',
            name: L['登录密码'],
            path: '/member/pwd/login'
          },
          {
            code: 'MemberPayPassword',
            name: L['支付密码'],
            path: '/member/pwd/pay'
          },
          {
            code: 'MemberResetPassword',
            name: L['重置密码'],
            path: '/member/pwd/reset'
          },
          {
            code: 'memberAddressList',
            name: L['地址管理'],
            path: '/member/address/list'
          }
        ]
      },
      // {
      //   code: 'messages',
      //   icon: 'icon-gerenzhongxinhuiyuanzhongxin',
      //   name: '消息中心',
      //   path: '/member/index'
      // },
      {
        code: 'money',
        icon: 'icon-gerenzhongxincaichanzhongxin',
        image_path: require('@/assets/user_center/wallet.png'),
        name: L['我的钱包'],
        path: '/member/index',
        child: [
          {
            code: 'MemberBalance',
            name: L['我的余额'],
            path: '/member/balance'
          },
          {
            code: 'MemberRecharge',
            name: L['账户充值'],
            path: '/member/recharge'
          }
          /* {
              code: "MemberCoupon",
              name: "我的优惠券",
              path: "/member/coupon"
            },
            {
              code: "MyPoint",
              name: "我的积分",
              path: "/member/myPoint"
            } */
        ]
      }
    ]
    const testIfShow = nav_info => {
      if (nav_info.code == 'MemberResetPassword') {
        if (store.state.memberInfo.hasPayPassword == 1) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    }
    const menuitem = path => {
      router.push(path)
    }
    const resolveIndex = index => {
      return index
    }
    const handleOpen = () => {}

    onMounted(() => {
      getInitInfo()
    })
    return {
      L,
      // leftNavMenu2,
      leftNavMenu,
      curCode,
      testIfShow,
      menuitem,
      resolveIndex,
      handleOpen,
      handleClose,
      memberInfo,
      isAuth,
      memberTrueName,
      memberIdCard
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-menu {
  border: none !important;
  background-color: #f7f7f7;
}

.el-submenu .el-menu-item {
  min-width: 160px !important;
}
.sld_member_left_nav {
  // background-color: #fff;
  color: #666;
  font-size: 12px;
  // border: 1px solid #ebebeb;
  // border-top: 1px solid #fff;
  // margin-top: -1px;
  padding-bottom: 100px;
  font-family: MicrosoftYaHei;
  width: 180px;
  float: left;
  margin-bottom: 20px;

  .authentication,
  .workdeskIcon,
  .icon {
    font-size: 16px;
    font-weight: 400;
    color: #888;
    margin-right: 12px;
  }

  .menu {
    margin: 9px 0;
    padding-left: 15px;
    font-size: 15px;
    font-weight: 600;
    font-family: MicrosoftYaHei-Bold;
    display: block;
    color: #666;
  }

  .submenu {
    line-height: 26px;
    padding-left: 53px;
    color: #333333;
    display: block;

    &:hover {
      font-weight: bold;
      color: $colorMain2;
    }

    &.cur_code_active {
      font-weight: bold;
      color: $colorMain2;
    }
  }
  .renzhengcenter {
    // margin-left: -3px !important;
  }
  .chicun {
    width: 16px;
    margin-right: 12px;
  }
  .chicun2 {
    width: 14px;
    margin-right: 12px;
  }
}
</style>
